import { TRANSFER_RECEIPTS } from '../actionTypes';

export const fetchTransferReceipts = (action) => ({
  type: TRANSFER_RECEIPTS.FETCH,
  payload: action.payload,
});
